import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import AddressList from "Constants/AddressList";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import phoneMask from "Components/Input/components/phoneMask";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import AppConfig from "Constants/AppConfig";
import {
  changeCustomerSearch,
  getGrouhMoshtari,
  InsertMoshtariData,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import {DialogActions} from "@material-ui/core";
import {convertToEnglishNumber} from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';
import * as Icons from "react-bootstrap-icons";

function AddCustomer() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { customerGroup } = useSelector((state) => ({
    customerGroup: state.customer.customerGroup,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    shomareEghtesadi: {
      type: "text",
      value: "",
      validation: null,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    mobile: {
      type: "mobile",
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        isPhone: true,
        minLength: 11,
      },
      col: {
        sm: 4,
        xs: 12,
      },
    },
    telephone: {
      type: "phone",
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    fax: {
      type: "phone",
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    customerGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    ostan: {
      type: "select",
      selectItems: AddressList.Ostan,
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    city: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    address: {
      type: "text",
      value: "",
      validation: null,
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });

  useEffect(() => {
    setControls({ customerGroup: { value: customerGroup[0] } });
    setControls({ customerGroup: { selectItems: customerGroup } });
  }, [customerGroup]);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "ostan") {
      const ctSelectItems = AddressList.city.filter(
        (s) => s.ostan === value.value
      );
      setControls({ city: { selectItems: ctSelectItems } });
      setControls({ city: { value: ctSelectItems[0] } });
    }
  };

  const onClear = () => {
    setFormValid({name: false , mobile: false});
    setCheckValid(false);
    setControls({ name: { value: "" } });
    setControls({ shomareEghtesadi: { value: "" } });
    setControls({ mobile: { value: "" } });
    setControls({ telephone: { value: "" } });
    setControls({ fax: { value: "" } });
    setControls({ customerGroup: { value: "" } });
    setControls({ ostan: { value: "" } });
    setControls({ city: { value: "" } });
    setControls({ address: { value: "" } });
  };

  const handleDialog = () =>{
    setOpenDialog(!openDialog);
    onClear();
  }

  const onFinish = async (e) => {
    e.preventDefault();
    if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
    ) {
      const {
        name,
        city,
        customerGroup,
        mobile,
        fax,
        telephone,
        shomareEghtesadi,
        address,
      } = controls;
      const enPhone =convertToEnglishNumber(mobile.value)
      const phoneWithCode = enPhone.replace("0" , "+98")
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: name.value,
          IdCity: city.value.value,
          IdGroup: customerGroup.value.value,
          Mobile: phoneWithCode,
          Tell: telephone.value,
          Fax: fax.value,
          ShoEconomic: shomareEghtesadi.value,
          Address: address.value,
        };

        await dispatch(InsertMoshtariData(data));
        handleDialog();
        dispatch(changeCustomerSearch({ Name: "" }));
      } catch (e) {
        showNotify({
          text: t('invalidInformation'),
          customClass: "error",
        });
      }
      handleDialog();
    } else {
      setCheckValid(true);
    }
  };

  const onEnter = async () => {
    onClear();
    const ct = AddressList.city.find((c) => c.value === AppConfig.defaultCity);
    const pr = AddressList.Ostan.find(
      (o) => o.value === AppConfig.defaultProvince
    );
    const ctSelectItems = AddressList.city.filter(
      (s) => s.ostan === AppConfig.defaultProvince
    );
    setControls({ ostan: { value: pr } });
    setControls({ city: { value: ct } });
    setControls({ city: { selectItems: ctSelectItems } });
    try {
      setLoading(true);
      const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
      await dispatch(getGrouhMoshtari(params));
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"moshtari_jadid"}/>}
        innerIcon={<Icons.PlusLg />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"moshtari_jadid"}/>} </p>
          </div>
          <DialogContent>
            {!loading ? (
              <Grid container spacing={2}>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                    >
                      {controls[key].type === "text" && (
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type="text"
                          value={controls[key].value}
                          checkValid={checkValid}
                        />
                      )}
                      {controls[key].type === "phone" && (
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type="text"
                          className={"phone"}
                          inputComponent={phoneMask}
                          checkValid={checkValid}
                        />
                      )}
                      {controls[key].type === "mobile" && (
                          <Input
                              setValue={setValue.bind(this)}
                              value={controls[key].value}
                              name={key}
                              validation={controls[key].validation}
                              label={<Translator id={key} />}
                              type="text"
                              className={"phone"}
                              maxlength= "11"
                              checkValid={checkValid}
                              helperText={'mobileExample'}
                          />
                      )}
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <MuiSkeleton xs={3} number={12} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default AddCustomer;
